
class BDWidget {

    constructor() {
        this._enable = false;
        this._wrapper = undefined;
        this.mountContent();
    }

    //指定类型
    getType() {
        return "base"
    }
    //构建元素
    mountContent() {
    }

    //更新内容
    updateContent() {

    }

    //绑定场景对象属性
    installHook() {
        Object.defineProperty(this.viewer, this.getType(), {
            value: this,
            writable: false
        })
    }


    /**
     * Installs to viewer
     * @param viewer
    */
    install(viewer) {
        this.viewer = viewer;
        this.installHook();
    }

    //设置状态
    set enable(enable) {
        if (this._enable === enable) {
            return this
        }
        this._enable = enable
        this._enable && this.bindEvent() //绑定事件
        !this._enable && this.unbindEvent() //解除绑定事件
        return this
    }

    get enable() {
        return this._enable
    }

    bindEvent() {
        this.viewer.scene.postRender.addEventListener(this.updateContent, this);
        this.viewer.container.appendChild(this._wrapper);
        this.show();
    }

    unbindEvent() {
        this.viewer.scene.postRender.removeEventListener(this.updateContent, this);
        this.viewer.container.removeChild(this._wrapper);
        this.hide();
    }


    hide() {
        if (this._wrapper) {
            this._wrapper.style.cssText = `
            visibility:hidden;
            `
        }
    }

    show() {
        if (this._wrapper) {
            this._wrapper.style.cssText = `
            visibility:visible;
            `
        }
    }


}


export default BDWidget